
import axios from 'axios';

const appBasePath = (import.meta.env.BASE_URL || '/').replace(/\/$/, '');
const locationsBaseURL = `${appBasePath === '' ? '' : appBasePath}/api/locations`;

const api = axios.create({
  baseURL: locationsBaseURL,
  withCredentials: true,
});

export interface Country {
  id: number;
  iso2: string;
  name: string;
  phonecode: string | null;
}

export interface State {
  iso2: string;
  name: string;
}

export interface City {
  name: string;
}

export const getCountries = async (): Promise<Country[]> => {
  const response = await api.get('/countries');
  const countries = Array.isArray(response.data) ? response.data : [];

  return [...countries].sort((a: Country, b: Country) => {
    if ((a.iso2 || '').toUpperCase() === 'MX') return -1;
    if ((b.iso2 || '').toUpperCase() === 'MX') return 1;
    return String(a.name || '').localeCompare(String(b.name || ''), 'es');
  });
};

export const getStatesOfCountry = async (countryIso: string): Promise<State[]> => {
  if (!countryIso) return [];
  const response = await api.get(`/countries/${countryIso}/states`);
  return response.data;
};

export const getCitiesOfState = async (countryIso: string, stateIso: string): Promise<City[]> => {
  if (!countryIso || !stateIso) return [];
  const response = await api.get(`/countries/${countryIso}/states/${stateIso}/cities`);
  return response.data;
};

